import * as React from "react";
import { Avatar, Badge, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import styles from "./topbar.module.scss";
import TextField from "../../common/form-control/form-control";
import textFieldStyles from "../../common/form-control/form-control-styles";
import BreadCrumbs from "./bread-crumbs";
import {
  removeAuthData,
  sessionOrLocalStorageClientPortalData
} from "../../../auth/authentication";
import { clientPhotoLink, routes } from "../../../constants";
import { setIsClientPortalUserAuthenticated } from "../../../slices/clientPortalAuthSlice";
import { RootState } from "../../../store";
import { getAccountDetails } from "../../../slices/clientPortalUserInfoSlice";
import DateShow from "./date";
import LocalStorageKeys from "../../common/enums/local-storage-keys";

const notificationIconStyles = {
  color: "white"
};

const TopBar = (): React.JSX.Element => {
  const { clientPortal } = routes;
  const loginRoute = `${clientPortal.name}/${clientPortal.subRoutes.login.name}`;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuToggle = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const user = useSelector((state: RootState) => state.clientPortalUserInfo.user);
  const dispatch = useDispatch();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    setAnchorEl(null);
    removeAuthData();
    dispatch(setIsClientPortalUserAuthenticated(false));
    dispatch(push(loginRoute));
  };
  React.useEffect(() => {
    if (!user?.userCreds?.id) {
      const storedData = sessionOrLocalStorageClientPortalData();
      try {
        const clientPortalUser = JSON.parse(storedData || "");
        if (clientPortalUser?.userId) {
          dispatch(getAccountDetails());
        }
      } catch (error) {
        window.location.href = loginRoute;
        sessionStorage.removeItem(LocalStorageKeys.USER);
        localStorage.removeItem(LocalStorageKeys.USER);
      }
    }
  }, [user?.userCreds?.id, dispatch, loginRoute]);

  return (
    <div className={styles.topBarContainer}>
      <div className={styles.topBarContent}>
        <TextField startIcon={<SearchIcon />} placeholder="Search Here" />
        <div className={styles.notification}>
          <IconButton
            className={styles.iconButton}
            aria-label="notifications"
            sx={textFieldStyles.icon}
          >
            <Badge
              badgeContent={4}
              color="warning"
              className={styles.badge}
              sx={notificationIconStyles}
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </div>
        <div className={styles.userContainer}>
          <Avatar alt="Remy Sharp" src={clientPhotoLink} />
          <div className={styles.userInfo}>
            <div>
              {/* @todo fetch client info */}
              <Typography className={styles.userName}>
                {user?.user?.firstName} {user?.user?.lastName}
              </Typography>
              <Typography className={styles.userRole}>User</Typography>
            </div>
            <div>
              <IconButton onClick={handleMenuToggle}>
                <KeyboardArrowDownIcon />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                  list: {
                    "aria-labelledby": "basic-button"
                  }
                }}
              >
                <MenuItem onClick={handleLogOut}>Log Out</MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>
      <BreadCrumbs />
      <DateShow />
    </div>
  );
};

export default TopBar;
